import { UserClient } from "@/modules/auth/constant/client.user";
const resource = "/shop/product";
export const productRepository = {
  getCategories: () => UserClient.get(`${resource}/categories`),

  create: (payload) => UserClient.post(`${resource}/store`, payload),

  update: (payload) => UserClient.post(`${resource}/update`, payload),
};
